// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ellipsis, mergeWithCss } from "@guestsupply/XDL/Utilities";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const sharedTextStyles: TypographyProps = {
    variant: "p",
    size: 14,
    color: "text.main",
    weight: "bold",
    css: css`
        letter-spacing: 0;
        line-height: 16px;
        margin-bottom: 0px;
        ${ellipsis(2)}
    `,
};

export const createProductDescriptionStyles = (styles: ProductDescriptionStyles = {}) => {
    return mergeWithCss<ProductDescriptionStyles, ProductDescriptionStyles>(
        {
            productDetailLink: {
                color: "text.main",
                typographyProps: {
                    ...sharedTextStyles,
                },
                css: css`
                    width: auto;
                    min-height: 32px;
                    margin-bottom: 8px;
                    align-items: baseline;
                `,
            },
            productDetailDescription: {
                ...mergeWithCss(sharedTextStyles, {
                    css: css`
                        min-height: 32px;
                        margin-bottom: 8px;
                    `,
                }),
            },
        },
        styles,
    );
};
